/**
 * AdminItemType
 *
 * Identifies an admin tool row inside the AdminSheet. The string values are
 * referenced from the static item list in `useAdminItems` and from the
 * AdminContent switch, so they must remain stable.
 *
 * Flutter source: lib/domain/entity/admin/admin_item.dart (the `AdminItemType`
 * enum, lines 10-15). Member order matches the Flutter ordinal order:
 * identityVerification, latestUsers, feedback, transactions.
 */

export enum AdminItemType {
  IDENTITY_VERIFICATION = 'identityVerification',
  LATEST_USERS = 'latestUsers',
  FEEDBACK = 'feedback',
  TRANSACTIONS = 'transactions',
}
